import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
  },
  {
    path: '/countries',
    name: 'Countries',
    component: () =>
      import(/* webpackChunkName: "countries" */ '../views/Countries.vue'),
  },
  {
    path: '/countries/detail/:countryName',
    name: 'CountryDetail',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "country-detail" */ '../views/CountryDetail.vue'
      ),
  },
  {
    path: '/about',
    name: 'About',
    component: () =>
      import(/* webpackChunkName: "countries" */ '../views/About.vue'),
  },
  {
    path: '/page-not-found',
    name: '404',
    component: () =>
      import(
        /* webpackChunkName: "not-found" */ '../views/errors/NotFound.vue'
      ),
    props: true,
  },
  {
    path: '*',
    redirect: {
      name: '404',
      params: { resource: 'page' },
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
